import { MouseEvent } from 'react';
import { IconButton, NewMenu, Stack } from '@common-components';
import { EditOutlined as EditOutlinedIcon, MoreVert } from '@icons';
import { useOptionsMenu } from 'hooks';
import { messages } from 'i18n';
import { CarriersColumns, columnConfig } from './CarriersTableHeader';
import { CarrierOnClick, ExtendedCarrier } from './types';

interface CarriersTableItemMenuProps {
  extendedCarrier: ExtendedCarrier;
  onEdit: CarrierOnClick;
}

export default function CarriersTableItemMenu({ extendedCarrier, onEdit }: CarriersTableItemMenuProps) {
  const moreOptionsMenu = useOptionsMenu();

  return (
    <Stack
      flex={columnConfig[CarriersColumns.MoreActions].flex}
      alignItems={columnConfig[CarriersColumns.MoreActions].align}
    >
      <IconButton
        variant="text"
        color="secondary"
        icon={MoreVert}
        onClick={(e?: MouseEvent<HTMLButtonElement>) => {
          moreOptionsMenu.openMenu(e);
        }}
      />
      <NewMenu
        optionsMenuState={moreOptionsMenu}
        placement="bottom-right"
        menuItems={[
          {
            key: 'more-actions',
            items: [
              {
                label: messages.carriersPage.editCarrier,
                startAdornment: EditOutlinedIcon,
                onClick: () => {
                  onEdit({ id: extendedCarrier.id });
                },
              },
            ],
          },
        ]}
      />
    </Stack>
  );
}
